$(document).ready(function () {  

  /*  메뉴 GNB hover 높이 */
  /* $(".LN000004 .multi_coll > .colitem > .sub-list").each(function(){
    var _h = $(this).closest(".multi_coll").height();
    $(this).css({ "min-height" : "auto" });
    $(this).css({ "min-height" : _h });
  }); 
  $(".LN000004 .gnb_hover > li > a ").hover(function(){ 
    var _h =  $(".sub-list", this).closest(".multi_coll").height() 
    $(".sub-list", this).css({ "min-height" : "auto" });
    $(".sub-list", this).css({ "min-height" : _h });
  }) */


  $(".LN000004 .multi_coll > .colitem > .sub-list").each(function(){
    var _h =  $(".gnb_col3 .multi_coll").height();
    $(this).css({ "min-height" : "auto" });
    $(this).css({ "min-height" : _h });
  }); 

  $(".LN000004 .gnb_hover > li > a ").hover(function(){ 
    var _h =  $(".gnb_col3 .multi_coll").height();
    $(".sub-list", this).css({ "min-height" : "auto" });
    $(".sub-list", this).css({ "min-height" : _h });
  });



  // dep1 hover 
  $(".menu-list > li").hover(function($e){
    var _hoverIndex =  $(this).index();    
    $(".multi_coll > .colitem").removeClass("dep1_hover");
    $(".multi_coll > .colitem").eq(_hoverIndex).addClass("dep1_hover");
  }, function(){    
    //$(".multi_coll > .colitem").delay(10).removeClass("dep1_hover");
  })
  
    // dep2 hover
  $(".menu_dep1 .multi_coll > .colitem").hover(function($e){
    var _hoverIndex =  $(this).index();
    $(".menu_dep1  .menu-list > li").eq(_hoverIndex).addClass("hover");

    $(".multi_coll > .colitem").removeClass("dep1_hover");
    $(this).addClass("hover");
  }, function(){
    $(".menu_dep1  .menu-list > li").removeClass("hover");
    $(this).removeClass("hover");
  });

  // dep3 hover
  $(".menu_dep1 .menu_dep3").hover( function(){
    $(this).closest("li").addClass("on");
  }, function(){
    $(this).closest("li").removeClass("on");
  })




  $(window).resize(function(){
    scrollLabelOnOff();    /// 스크롤 라벨 
  })
  
  /* 타이어 검색, 스티키바 */
  function scrollLabelOnOff(){ 
    $(".labelscroll-area .scroll-inner").each( function(){
      $(this).hasScrollBar(); // ture of false
    }) 
  }
  $.fn.hasScrollBar = function() { 
    // 스크롤 있는지 여부 판단
    var _B =  (this.prop("scrollWidth") == 0 && this.prop("clientWidth") == 0)
    || (this.prop("scrollWidth") > this.prop("clientWidth"));
    _B ? $(this).closest(".labelscroll-area").addClass("scroll_on") : $(this).closest(".labelscroll-area").removeClass("scroll_on");
    return _B
    
  };
  $(".labelscroll-area .scroll-inner").hasScrollBar();
  



})//ready

